import React, { useState, Fragment, useEffect } from "react";
import styles from "./Applications.module.css";
import {
  Row,
  Col,
  Card,
  Tooltip,
  Space,
  Spin,
  Input,
  Button,
  Table,
  Tag,
  Modal,
  Typography,
} from "antd";
import {
  CloudDownloadOutlined,
  InfoCircleOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { fetchUserVal, fetchJsData } from "../../../../api";
import { uniqueByKey } from "../../../../api/util";
import { CSVLink } from "react-csv";
const { Search } = Input;
const { Text } = Typography;

const fetchSslUserSearch = async (rel, type) => {
  const data = await fetchUserVal("fetConAppSsl", {
    firstVal: rel,
    secondVal: rel,
  });
  return data;
};

export const FetchSslTabSearch = (props) => {
  const [load, setLoad] = useState(props.load);
  const [searchVal, setSearchVal] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [origData, setOrigData] = useState([]);
  const [searchIndex, setSearchIndex] = useState([]);
  const [loading, setLoading] = useState(true);
  const [app, setApp] = useState("");
  const [trig, setTrig] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const renderContent = (value, row, index) => {
    // alert(app);
    return (
      <a
        onClick={() => {
          setApp(value);
          setOpenModal(true);
          setTrig(!trig);
          // openModal();
        }}
      >
        {value}
      </a>
    );
  };
  let sameKey;
  const ColSsl = [
    {
      title: () => {
        return (
          <>
            Application name{" "}
            {loading ? (
              <div>
                <Spin size="small" />
              </div>
            ) : (
              <Tag color="processing">
                {uniqueByKey(filteredData, "current_name").length}
              </Tag>
            )}
          </>
        );
      },
      dataIndex: "current_name",
      key: "current_name",
      fixed: "left",
      width: "40%",
      sorter: (a, b) =>
        a.current_name ? a.current_name.localeCompare(b.current_name) : 1,
      render: (value) => renderContent(value),
      // filters:
      //   filteredData.length > 0 && filteredData
      //     ? Array.from(
      //         new Set(filteredData.map((item) => item.current_name))
      //       ).map((x) => {
      //         return {
      //           text: x,
      //           value: x,
      //         };
      //       })
      //     : [],
      // onFilter: (value, record) => record.current_name.indexOf(value) === 0,

      // render: (value, row, index) => {
      //   const obj = {
      //     children: renderContent(value),
      //     props: {},
      //   };
      //   if (!(sameKey !== value)) {
      //     obj.props.rowSpan = 0;
      //     return obj;
      //   }
      //   const count = filteredData.filter(
      //     (item) => item.current_name === value
      //   ).length;
      //   sameKey = value;
      //   obj.props.rowSpan = count;
      //   return obj;
      // },
    },
    {
      title: "App Details",
      children: [
        {
          title: "Platform",
          dataIndex: "platform",
          key: 1,
        },
        {
          title: "Process Name",
          dataIndex: "process_name",
          key: 2,
        },
        {
          title: "Native App Name",
          dataIndex: "native_app_name",
          key: 3,
        },
      ],
    },
  ];

  useEffect(() => {
    setLoading(true);
    const crawl = (user, allValues) => {
      if (!allValues) allValues = [];
      for (var key in user) {
        if (typeof user[key] === "object") crawl(user[key], allValues);
        else allValues.push(user[key] + " ");
      }
      return allValues;
    };
    const fetchData = async () => {
      const { data: users } = await fetchSslUserSearch(
        props.usrRel,
        props.type
      );
      setOrigData(users);
      setFilteredData(users);
      const searchInd = users.map((user) => {
        const allValues = crawl(user);
        return { allValues: allValues.toString() };
      });
      setSearchIndex(searchInd);
      if (users) setLoading(false);
    };
    fetchData();
  }, [props.submit]);

  useEffect(() => {
    if (searchVal) {
      const reqData = searchIndex.map((user, index) => {
        if (user.allValues.toLowerCase().indexOf(searchVal.toLowerCase()) >= 0)
          return origData[index];
        return null;
      });
      setFilteredData(
        reqData.filter((user) => {
          if (user) return true;
          return false;
        })
      );
    } else setFilteredData(origData);
  }, [searchVal, origData, searchIndex, props.submit]);

  return (
    <>
      <div>
        <Row gutter={16}>
          <Col className="gutter-row" span={1}></Col>
          <Col span={22}>
            <Card
              title={
                "Release - " + props.usrRel.split("snapshot_v")[1].split("_")[0]
              }
              size="small"
              headStyle={{ backgroundColor: "#F0F8FF", border: 0 }}
              extra={
                <Row>
                  <Col span={21}>
                    <Input
                      onChange={(e) => setSearchVal(e.target.value)}
                      prefix={
                        <SearchOutlined className="site-form-item-icon" />
                      }
                      placeholder="Crawl Search"
                      allowClear
                      enterButton
                    />
                  </Col>
                  <Col span={1}></Col>
                  <Col className="gutter-row" span={2}>
                    {" "}
                    <div>
                      {loading ? (
                        <div>
                          <Spin size="small" />
                        </div>
                      ) : (
                        <Tooltip
                          placement="topRight"
                          title="Download Status Report"
                          arrowPointAtCenter
                          // color={"#CCD1D1"}
                          // key={"#2db7f5"}
                        >
                          <CSVLink
                            filename={"Ssl Report.csv"}
                            data={filteredData}
                            className="btn btn-primary"
                          >
                            <CloudDownloadOutlined
                              style={{ fontSize: "29px" }}
                            />
                          </CSVLink>
                        </Tooltip>
                      )}
                    </div>
                  </Col>
                </Row>
              }
            >
              <Fragment>
                <Table
                  // rowKey="application_id"
                  size="small"
                  scroll={{ x: 550, y: 900 }}
                  style={{ margin: "2px" }}
                  dataSource={filteredData.map((d, i) => ({ key: i, ...d }))}
                  loading={loading}
                  columns={ColSsl}
                  // pagination={false}
                  pagination={{
                    defaultPageSize: 50,
                    showSizeChanger: true,
                    pageSizeOptions: ["10", "30", "60", "100", "1000"],
                  }}
                  bordered={true}
                />
              </Fragment>
              <Fragment>
                <OpMod
                  usrRel={props.usrRel}
                  rel={props.rel}
                  type={props.type}
                  app={app}
                  openModal={openModal}
                  trig={trig}
                />
              </Fragment>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

const OpMod = (props) => {
  const [app, setApp] = useState(props.app);
  const [load, setLoad] = useState(true);
  const [usrRel, setUsrRel] = useState(props.usrRel);
  const [rel, setRel] = useState(props.rel);
  const [modData, setModData] = useState({
    conActName: "conAct",
    conAct: "",
    conActDom: "",
  });
  const [comp, setComp] = useState(false);
  const [showDom1, setShowDom1] = useState(false);
  const [showDom2, setShowDom2] = useState(false);
  const [show, setShow] = useState(false);
  const openModal = () => setShow(props.openModal);
  const closeModal = () => {
    setShow(false);
    setComp(false);
  };
  const prevRel = rel - 1;
  const ppRel = rel - 2;
  const [compDomData, setCompDomData] = useState([
    {
      release: "",
      actName: "",
      domain: "",
    },
  ]);

  // initial effect
  useEffect(() => {
    setApp(props.app);
    if (props.openModal === true) {
      openModal();
      fetchData();
      setCompDomData([
        {
          release: "",
          actName: "",
          domain: "",
        },
      ]);
    }
  }, [props.app, props.trig]);

  // Compare effect
  useEffect(() => {
    if (!compDomData[0]["release"]) {
      fetchCompData();
    }
  }, [comp]);

  const fetchData = async () => {
    setLoad(true);
    setUsrRel(props.usrRel);
    const fetConActivity = await fetchUserVal("fetConActivity", {
      firstVal: props.usrRel,
      secondVal: props.usrRel,
      thirdVal: props.usrRel,
      fourthVal: props.app,
    });

    const fetConAppAct = await fetchJsData({
      type: "fetch",
      qry: "fetConAppActDom",
      firstVal: props.app,
      secondVal: props.usrRel,
      thirdVal: props.usrRel,
      fourthVal: props.usrRel,
      fifthVal: props.usrRel,
      sixthVal: props.usrRel,
    });

    // setRel("snapshot_" + relVersion["version"]);
    setModData({
      conActName: fetConActivity["data"][0]["category_name"],
      conAct: fetConAppAct["data"][1][0]["activityV1"],
      conActDom: fetConAppAct["data"][1][0]["domV1"],
    });
    setLoad(false);
  };

  const fetchCompData = async () => {
    setLoad(true);
    setUsrRel(props.usrRel);
    if (show) {
      const domData = await fetchJsData({
        type: "fetch",
        qry: "fetConDoms",
        preProcFunc: "appDomInfo",
        preProcess: true,
        firstVal: props.app,
        secondVal: "snapshot_v" + ppRel + "_0_0",
        thirdVal: "snapshot_v" + ppRel + "_0_0",
        fourthVal: "snapshot_v" + prevRel + "_0_0",
        fifthVal: "snapshot_v" + prevRel + "_0_0",
        sixthVal: "snapshot_v" + rel + "_0_0",
        seventhVal: "snapshot_v" + rel + "_0_0",
      });

      // setCompData(actData["data"]);
      setCompDomData(domData["data"]);
    }
    setLoad(false);
  };

  const compare = async () => {
    setShowDom1(false);
    setShowDom2(false);
    setComp(!comp);
  };

  return (
    <Modal
      // title={app + " > " + modData["conActName"]}
      title={
        load ? (
          <div>
            <Spin size="small" />
          </div>
        ) : (
          <Row gutter={16}>
            <Col className="gutter-row" span={19}>
              <Text keyboard>
                <>{app + " > " + modData["conActName"]}</>
              </Text>
            </Col>

            <Col className="gutter-row" span={2}>
              <Space size="small" align="end">
                <Button
                  type="dashed"
                  shape="round"
                  // icon={<OrderedListOutlined />}
                  onClick={compare}
                  style={{ backgroundColor: "#f0f5ff" }}
                  size="small"
                >
                  compare
                </Button>
                {comp ? (
                  <Tooltip
                    title={
                      <div
                        style={{
                          fontSize: "9px",
                          fontFamily: "Gill, Helvetica, sans-serif",
                        }}
                      >
                        <ul>
                          <li>
                            <p>
                              <Text>No Change</Text>: indicates same as previous
                              release
                            </p>
                          </li>
                          <li>
                            <p>
                              <Text delete type="danger">
                                Red Text
                              </Text>
                              : indicates removed in this release
                            </p>
                            {/* <span style={{ color: "red" }}>Red text</span> */}
                          </li>
                          <li>
                            <p>
                              <Text type="success">Green Text</Text>: indicates
                              added in this release
                            </p>
                          </li>
                        </ul>
                      </div>
                    }
                    color="#425162"
                    // style={{ width: "700px" }}
                  >
                    <InfoCircleOutlined />
                  </Tooltip>
                ) : (
                  <></>
                )}
              </Space>
            </Col>
          </Row>
        )
      }
      visible={show}
      onOk={closeModal}
      confirmLoading={load}
      onCancel={closeModal}
      width={"50%"}
    >
      <Card
        className={styles.chart}
        size="small"
        headStyle={{ border: 2 }}
        bordered={true}
        loading={load}
      >
        {comp ? (
          <>
            <Card
              className={styles.chart}
              title={<Text keyboard> Domain </Text>}
              size="small"
              headStyle={{ backgroundColor: "#F0F8FF", border: 1 }}
              bordered={true}
              loading={load}
            >
              {load ? (
                <div>
                  <Spin size="small" />
                </div>
              ) : (
                <>
                  <Table
                    rowKey="appDom_id"
                    size="small"
                    bordered
                    pagination={false}
                    dataSource={compDomData}
                    columns={[
                      {
                        title: () => {
                          return (
                            <div style={{ fontSize: "12px" }}>Release </div>
                          );
                        },
                        dataIndex: "release",
                        key: "release",
                        fixed: "left",
                        width: "10%",
                        render: (text) => (
                          <span style={{ fontSize: "11px" }}>{text}</span>
                        ),
                      },
                      {
                        title: () => {
                          return (
                            <div style={{ fontSize: "12px" }}>Domain </div>
                          );
                        },
                        dataIndex: "domName",
                        key: "domName",
                        fixed: "left",
                        responsive: ["sm"],
                        width: "90%",
                        render: (text, row) => (
                          <>
                            {row.id == 1 ? (
                              text ? (
                                <span style={{ fontSize: "11px" }}>
                                  {text.replaceAll(",", ", ")}
                                </span>
                              ) : (
                                text
                              )
                            ) : row.id == 2 ? (
                              <div
                                onClick={() => {
                                  setShowDom1(!showDom1);
                                }}
                                style={{ fontSize: "11px" }}
                              >
                                {!showDom1 ? (
                                  row.domComp == "No Change" ? (
                                    <a>{row.domComp}</a>
                                  ) : row.domAdded.length != 0 &&
                                    row.domRemoved.length != 0 ? (
                                    <>
                                      <Text type="success">
                                        {row.domAdded.toString().includes(",")
                                          ? row.domAdded
                                              .toString()
                                              .replaceAll(",", ", ")
                                          : row.domAdded.toString()}{" "}
                                      </Text>{" "}
                                      <Text delete type="danger">
                                        {row.domRemoved.toString().includes(",")
                                          ? row.domRemoved
                                              .toString()
                                              .replaceAll(",", ", ")
                                          : row.domRemoved.toString()}{" "}
                                      </Text>
                                    </>
                                  ) : row.domAdded.length != 0 ? (
                                    <Text type="success">
                                      {row.domAdded.toString().includes(",")
                                        ? row.domAdded
                                            .toString()
                                            .replaceAll(",", ", ")
                                        : row.domAdded.toString()}{" "}
                                    </Text>
                                  ) : (
                                    <Text delete type="danger">
                                      {row.domRemoved.toString().includes(",")
                                        ? row.domRemoved
                                            .toString()
                                            .replaceAll(",", ", ")
                                        : row.domRemoved.toString()}{" "}
                                    </Text>
                                  )
                                ) : text ? (
                                  text.replaceAll(",", ", ")
                                ) : (
                                  text
                                )}
                              </div>
                            ) : (
                              <div
                                onClick={() => {
                                  setShowDom2(!showDom2);
                                }}
                                style={{ fontSize: "11px" }}
                              >
                                {!showDom2 ? (
                                  row.domComp == "No Change" ? (
                                    <a>{row.domComp}</a>
                                  ) : row.domAdded.length != 0 &&
                                    row.domRemoved.length != 0 ? (
                                    <>
                                      <Text type="success">
                                        {row.domAdded.toString().includes(",")
                                          ? row.domAdded
                                              .toString()
                                              .replaceAll(",", ", ")
                                          : row.domAdded.toString()}{" "}
                                      </Text>{" "}
                                      <Text delete type="danger">
                                        {row.domRemoved.toString().includes(",")
                                          ? row.domRemoved
                                              .toString()
                                              .replaceAll(",", ", ")
                                          : row.domRemoved.toString()}{" "}
                                      </Text>
                                    </>
                                  ) : row.domAdded.length != 0 ? (
                                    <Text type="success">
                                      {row.domAdded.toString().includes(",")
                                        ? row.domAdded
                                            .toString()
                                            .replaceAll(",", ", ")
                                        : row.domAdded.toString()}{" "}
                                    </Text>
                                  ) : (
                                    <Text delete type="danger">
                                      {row.domRemoved.toString().includes(",")
                                        ? row.domRemoved
                                            .toString()
                                            .replaceAll(",", ", ")
                                        : row.domRemoved.toString()}{" "}
                                    </Text>
                                  )
                                ) : text ? (
                                  text.replaceAll(",", ", ")
                                ) : (
                                  text
                                )}
                              </div>
                            )}
                          </>
                        ),
                      },
                    ]}
                    loading={load}
                  />
                </>
              )}
            </Card>
          </>
        ) : (
          <>
            <Card
              className={styles.chart}
              title={<Text keyboard> Domain </Text>}
              size="small"
              headStyle={{ backgroundColor: "#F0F8FF", border: 1 }}
              bordered={true}
              loading={load}
            >
              <Text style={{ fontSize: "12px" }}>
                {modData["conActDom"]
                  ? modData["conActDom"].replaceAll(",", ", ")
                  : modData["conActDom"]}
              </Text>
            </Card>
          </>
        )}
      </Card>
    </Modal>
  );
};

const Details = (props) => {
  let sameKey;
  const [app, setApp] = useState("data");
  const [trig, setTrig] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const renderContent = (value, row, index) => {
    // alert(app);
    return (
      <a
        onClick={() => {
          setApp(value);
          setOpenModal(true);
          setTrig(!trig);
          // openModal();
        }}
      >
        {value}
      </a>
    );
  };
  const columns = [
    {
      title: "District",
      dataIndex: "state_name",
      key: "state_name",
      render: (value, row, index) => {
        const obj = {
          children: renderContent(value),
          props: {},
        };
        if (!(sameKey !== value)) {
          obj.props.rowSpan = 0;
          return obj;
        }
        const count = data.filter((item) => item.state_name === value).length;
        sameKey = value;
        obj.props.rowSpan = count;
        return obj;
      },
    },
    {
      title: "Exam Details",
      children: [
        {
          title: "Gender Details",
          dataIndex: "gender",
          key: 1,
        },
        {
          title: "Total number of candidates",
          dataIndex: "total",
          key: 2,
        },
        {
          title: "Total Number of candidates passed",
          dataIndex: "passed_total",
          key: 3,
        },
      ],
    },
  ];

  const data = [
    {
      state_name: "Karnataka",
      gender: "Boys",
      total: Math.floor(Math.random() * 90 + 10),
      passed_total: Math.floor(Math.random() * 90 + 10),
    },
    {
      state_name: "Karnataka",
      gender: "Girls",
      total: Math.floor(Math.random() * 90 + 10),
      passed_total: Math.floor(Math.random() * 90 + 10),
    },
    {
      state_name: "Karnataka",
      gender: "Transgender",
      total: Math.floor(Math.random() * 90 + 10),
      passed_total: Math.floor(Math.random() * 90 + 10),
    },
    {
      state_name: "Kerala",
      gender: "Boys",
      total: Math.floor(Math.random() * 90 + 10),
      passed_total: Math.floor(Math.random() * 90 + 10),
    },
    {
      state_name: "Kerala",
      gender: "Girls",
      total: Math.floor(Math.random() * 90 + 10),
      passed_total: Math.floor(Math.random() * 90 + 10),
    },
    {
      state_name: "Kerala",
      gender: "Transgender",
      total: Math.floor(Math.random() * 90 + 10),
      passed_total: Math.floor(Math.random() * 90 + 10),
    },
    {
      state_name: "Tamilnadu",
      gender: "Boys",
      total: Math.floor(Math.random() * 90 + 10),
      passed_total: Math.floor(Math.random() * 90 + 10),
    },
    {
      state_name: "Tamilnadu",
      gender: "Girls",
      total: Math.floor(Math.random() * 90 + 10),
      passed_total: Math.floor(Math.random() * 90 + 10),
    },

    {
      state_name: "Goa",
      gender: "Boys",
      total: Math.floor(Math.random() * 90 + 10),
      passed_total: Math.floor(Math.random() * 90 + 10),
    },
    {
      state_name: "Goa",
      gender: "Girls",
      total: Math.floor(Math.random() * 90 + 10),
      passed_total: Math.floor(Math.random() * 90 + 10),
    },
    {
      state_name: "Andhra Pradesh",
      gender: "Boys",
      total: Math.floor(Math.random() * 90 + 10),
      passed_total: Math.floor(Math.random() * 90 + 10),
    },
  ];

  return (
    <>
      <Table
        columns={columns}
        dataSource={data.map((d, i) => ({ key: i, ...d }))}
        // dataSource={data}
        pagination={false}
        bordered={true}
      />
      <Fragment>
        <OpMod
          usrRel={props.usrRel}
          rel={props.rel}
          type={props.type}
          app={app}
          openModal={openModal}
          trig={trig}
        />
      </Fragment>
    </>
  );
};
